import React from 'react';
import PropTypes from 'prop-types';
import SelectFieldMultiSelect from 'components/input/SelectFieldMultiSelect/SelectFieldMultiSelect';
import utils from 'helpers/utils';
import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import { fetchCategories } from 'store/actions/categories/fetchCategories';
import compose from 'recompose/compose';

class CategoriesFilter extends React.Component {
    componentDidMount() {
        const { categories, fetchCategories } = this.props;

        if (utils.isEmpty(categories)) {
            fetchCategories({
                size: 96,
                offset: 0,
                sort: {
                    field: 'name',
                    order: 'asc',
                },
            });
        }
    }

    render() {
        const { categories, source } = this.props;

        return (
            <SelectFieldMultiSelect
                choices={ categories }
                fullWidth={ true }
                label='resources.products.fields.category_id'
                source={ source }
                { ...this.props }
            />
        );
    }
}

CategoriesFilter.defaultProps = {
    source: 'category_id',
};

CategoriesFilter.propTypes = {
    categories: PropTypes.array,
    fetchCategories: PropTypes.func.isRequired,
    source: PropTypes.string,
};

const categoriesSelector = (state) => {
    return state.categories.data;
};

const getCategories = createSelector(
    categoriesSelector,
    (categories) => {
        if (utils.isEmpty(categories)) {
            return [];
        }

        return utils.map(categories, function (item) {
            return {
                id: item.id,
                name: item.name,
            };
        });
    },
);

const mapStateToProps = (state, props) => {
    return {
        categories: getCategories(state, props),
    };
};

const mapDispatchToProps = {
    fetchCategories: fetchCategories,
};

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
);

export default enhance(CategoriesFilter);



// WEBPACK FOOTER //
// ./src/components/list/Filters/types/CategoriesFilter.js